<template>
  <div class="wy-alert-panel">
    <div class="div-content">
      Performance alerts are triggered each time data from the past day is processed and meets the configured rule conditions for topic and bot metrics. Alerts are not impacted by your filter selection.
    </div>
    <div v-if="controller.alertList.length>0">
      <div class="wy-alert-panel-item" :class="{'active': alertItem.isNew}" v-for="(alertItem, index) in controller.alertList" :key="index" @mouseover="controller.alertsPanelMouseOver">
        <span v-if="alertItem.isNew" class="blue-dot"></span>
        <div class="div-item div-header-title">
          <span class="product">{{controller.getPageName(alertItem)}}</span>
          <span class="dot">&nbsp;</span>
          <span class="date">{{controller.getDate(alertItem.actionDate)}}</span>
        </div>
        <div class="div-item div-title">{{controller.getMetricName(alertItem)}}</div>
        <div class="div-item" v-for="(alert, index) in alertItem.alerts"  :key="index">
          <div v-if="alert.type=='overall'" class="label ellipsis">
            {{alert.label}} <span class="sub-content">across all topics</span>
          </div>
          <div v-else class="label ellipsis" @mouseover="controller.mouseover($event, alert.label)" @mouseout="controller.mouseout">
            {{alert.label}}
          </div>
          <div class="value">{{alert.display.currentValue}}</div>
          <div v-if="controller.getMetricReverse(alertItem)" class="change-value" :class="{'red': (alert.display.changeFlag>0), 'green': (alert.display.changeFlag<0), 'gray': (alert.display.changeFlag==0)}" @mouseover="controller.handleTooltipOver($event, alert)" @mouseout="controller.handleTooltipOut($event)">
            <span v-if="alert.display.changeFlag==0" class="change-flag-na">N/A </span><i v-else :class="{'el-icon-top': (alert.display.changeFlag>0), 'el-icon-bottom': (alert.display.changeFlag<0)}"></i><!-- //NOSONAR -->{{(alert.display.changeFlag==0) ? "" : alert.display.previousValue}}
          </div>
          <div v-else class="change-value" :class="{'green': (alert.display.changeFlag>0), 'red': (alert.display.changeFlag<0), 'gray': (alert.display.changeFlag==0)}" @mouseover="controller.handleTooltipOver($event, alert)" @mouseout="controller.handleTooltipOut($event)">
            <span v-if="alert.display.changeFlag==0" class="change-flag-na">N/A </span><i v-else :class="{'el-icon-top': (alert.display.changeFlag>0), 'el-icon-bottom': (alert.display.changeFlag<0)}"></i><!-- //NOSONAR -->{{(alert.display.changeFlag==0) ? "" : alert.display.previousValue}}
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="controller.processAlertStatus==1" class="no-data-content">
        No alerts triggered for the configured values.
      </div>
      <div v-else-if="controller.processAlertStatus==2 && controller.isRoleAllow([4201, 4001, 4101, 4111, 4121, 4141, 900001])" class="no-data-content">
        No alerts configured. Please setup alert rules to receive notifications and stay updated on data changes for metrics that matter to you.
      </div>
      <div v-else class="no-data-content">
        No alerts configured.
      </div>
      <div v-if="controller.isRoleAllow([4201, 4001, 4101, 4111, 4121, 4141, 900001])" class="config-link" @click="controller.handleGoToConfigration">
        Go to Alerts Configuration
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-bot-analytics-alert-template',
  props: ['controller']
})
</script>

